import {
    BASE_URL
} from '../../config';

import {
    GET_ALL_RESTAURANTS,
    ADD_RESTAURANT,
    UPDATE_RESTAURANT,
    DELETE_RESTAURANT,
    GET_REGIONS,
} from './restaurant.actionsTypes';

import axios from 'axios';
import Notifier from '../../components/message/Notifier';

export const getAllRestaurants = () => {
    return (dispatch) => {
        axios.get(`${BASE_URL}v2/restaurant/`)
        .then((response) => {
            if (response.data) {
                dispatch({
                    type: GET_ALL_RESTAURANTS,
                    restaurants: response.data
                });
            }
        });
    }
}

export const addRestaurantData = (restaurant) => {
    return {
        type: ADD_RESTAURANT,
        restaurant
    };
};

export const addRestaurantByApi = (restaurant) => {
    return (dispatch) => {
        return axios.post(`${BASE_URL}restaurant/`, restaurant)
            .then((response) => {
                dispatch(addRestaurantData(response.data));
                Notifier.success('_restaurant_successfully_added_', '_restaurant_added_');
            })
            .catch((e) => {
                if (e && e.response && e.response.status === 403) {
                    const msg = e.response.data && e.response.data.messages && e.response.data.messages[0] && e.response.data.messages[0].text ? e.response.data.messages[0].text : 'sysACCESS_DENIED';
                    Notifier.error(msg);
                } else {
                    Notifier.warning('_something_went_wrong_');
                }
                throw e;
            });
    };
};

export const updateRestaurantData = (restaurant, id) => {
    return {
        type: UPDATE_RESTAURANT,
        restaurant,
        id
    };
};

export const updateRestaurantByApi = (id, restaurant) => {
    return (dispatch) => {
        return axios.put(`${BASE_URL}restaurant/${id}`, restaurant)
            .then((response) => {
                if (response.data) {
                    dispatch(updateRestaurantData(response.data, id));
                    Notifier.success('_restaurant_successfully_updated_', '_restaurant_updated_');
                }
            })
            .catch((e) => {
                if (e && e.response && e.response.status === 403) {
                    const msg = e.response.data && e.response.data.messages && e.response.data.messages[0] && e.response.data.messages[0].text ? e.response.data.messages[0].text : 'sysACCESS_DENIED';
                    Notifier.error(msg);
                } else {
                    Notifier.warning('_something_went_wrong_');
                }
                throw e;
            });
    };
};

export const activateResaurant = (data, cb = () =>{}) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}restaurant/activate`, data)
        .then((response) => {
            if (response.data) {
                dispatch(updateRestaurantData(response.data, data._id));
                Notifier.success('_restaurant_successfully_updated_', '_restaurant_updated_');
                cb()
            }
        });
    };
};

export const deleteRestaurantData = (restaurant) => {
    return {
        type: DELETE_RESTAURANT,
        restaurant
    };
};

export const deleteRestaurantByApi = (id) => {
    return (dispatch) => {
        axios.put(`${BASE_URL}restaurant/delete/${id}`)
        .then((response) => {
            if (response.data) {
                dispatch(deleteRestaurantData(response.data));
                Notifier.success('_restaurant_successfully_deleted_', '_restaurant_deleted_');
            }
        });
    };
}

export const getRegions = () => {
    return (dispatch) => {
        return axios.get(`${BASE_URL}restaurant/regions`)
            .then((response) => {
                if (response.data) {
                    dispatch({
                        type: GET_REGIONS,
                        regions: response.data,
                    });
                    return response.data;
                }
            });
    };
};
